<div class="card">
    <span>{{props['orientation']}}</span>
    <div class="card-body" [ngClass]="props['orientation']">
      <ng-container #fieldComponent></ng-container>
    </div>
  </div>